<template>
  <transition name="fade">
    <div class="mod-req-app">
      <div class="mod-req-app-container">
        <div class="btn-close" @click="closeModal()">
          X
        </div>
        <div class="title-wrapper">
          <div class="title-big title-color__red">
            PRAQUALIFIKASI
          </div>
        </div>
        <div>
          <div class="flex-space-between">
            <div>
              <input type="radio" value="9" v-model="type" class="mr10" />
              <label>DATA LEGAL</label>
            </div>
            <div>
              <input type="radio" value="10" v-model="type" class="mr10" />
              <label>K3L</label>
            </div>
            <div>
              <input type="radio" value="11" v-model="type" class="mr10" />
              <label>KPLH</label>
            </div>
          </div>
        </div>
        <div>Nama Vendor</div>
        <div class="half-input-wrapper">
          <v-select class="style-chooser" placeholder="Cari Vendor" label="nama_vendor" :options="vendors"
            v-model="choosedVendor" @search="typingVendor" />
        </div>

        <div>
          <div>Nama PIC <span class="text-ast">*</span></div>
          <input type="text" class="input-100" v-model="pic" />
        </div>
        <div>
          <div>No. Telepon PIC <span class="text-ast">*</span></div>
          <vue-tel-input v-model="phone" v-bind="vueTel.props" />
        </div>
        <div>
          <div>Email PIC <span class="text-ast">*</span></div>
          <input type="text" class="input-100" v-model="email" />
        </div>
        <div class="mb10" v-if="type == 11">
          <div>Pendaftaran Company GEMS<span class="text-ast">*</span></div>
          <select class="input-100" style="padding: 5px 1px" v-model="choosed_company">
            <option :value="''">Choose Company</option>
            <option v-for="(list, index) in companies" :value="list.kode" :key="index">
              {{ list.nama_perusahaan }}
            </option>
          </select>
        </div>

        <div>
          <div>Catatan Untuk SIPM</div>
          <input type="text" class="input-100" v-model="note" />
        </div>
        <div class="mt20 text-grey text-small">
          Catatan: Jika legalitas dokumen belum lengkap, mohon untuk menunggu
          SIPM untuk meminta vendor melengkapi dokumen Legalitas terlebih dahulu
        </div>
      </div>
      <div class="one-btn-center">
        <div class="btn-big">
          <div class="btn-wrapper btn-wrapper__red" @click="submit()">
            Submit
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      vueTel: {
        props: {
          placeholder: 'Enter your phone',
          mode: 'international',
          inputOptions: {
            showDialCode: true,
          },
          disabledFormatting: false,
        },
      },
      vendors: [],
      pic: '',
      type: null,
      name: '',
      phone: '',
      email: '',
      note: null,
      timeout: null,
      companies: [],
      choosed_company: '',
    }
  },
  async created() {
    const gems = await this.$gemsCompanies()

    this.companies = gems
  },
  computed: {
    choosedVendor: {
      get() {
        return this.$store.state.myRequest.choosedVendor
      },
      set(newValue) {
        this.$store.commit('myRequest/SET_DATA', {
          name: 'choosedVendor',
          value: newValue,
        })
      },
    },
  },
  methods: {
    checkForm() {
      let arr = [
        [this.choosedVendor, 'Nama Vendor'],
        [this.pic, 'Nama PIC'],
        [this.type, 'Type Praqualifikasi'],
        [this.phone, 'Nomor Telepon PIC'],
        [this.isEmailValid(this.email), 'Email PIC'],
      ]

      if (this.type == 11) {
        arr.push([this.choosed_company, 'Pendaftaran Company GEMS'])
      }

      return this.multiConditions(arr)
    },
    submit() {
      if (this.checkForm()) {
        this.$store.dispatch('myRequest/createPraqualifikasi', {
          type: this.type,
          vendor: this.choosedVendor.id,
          nama_vendor: this.choosedVendor.nama_vendor,
          pic_vendor: this.pic,
          pic_no_telepon: this.phone,
          pic_email: this.email,
          note: this.note,
          gems_company: this.choosed_company,
        })
      }
    },
    closeModal() {
      this.$store.commit('modalReqApp/SET_VALUE', {
        name: 'modalPraqualifikasi',
        value: false,
      })
    },
    typingVendor(search, loading) {
      clearTimeout(this.timeout)

      let self = this
      this.timeout = setTimeout(() => {
        if (search.length > 2) {
          self.getVendor(search)
        }
      }, 1500)
    },
    async getVendor(search) {
      this.vendors = await this.$vendorName(search)
    },
    async getVendorMounted(nama_vendor, alias_profile) {
      let vendor = await this.$vendorName(nama_vendor)
      let filterVendor = ''
      if (vendor && vendor.length > 0) {
        filterVendor = vendor.filter(
          i => i.nama_vendor == nama_vendor + ', ' + alias_profile
        )
      }
      this.choosedVendor = filterVendor[0]
    },
  },
}
</script>
